import { MeteringType, DistributionApprovalStatus, DistributionFunctionalStatus, FunctionControlStatus } from '@enums';
import { 
  DisruptionInfo, 
  MeteringPointFunctionControl, 
  MeteringPointIntelligyStatus, 
  MeteringPointReadingPoint 
} from '@model';

export class MeteringPoint {
  id?: number;
  name?: string;
  type?: string;
  meteringType?: MeteringType;
  area?: number;
  categoryId?: string;
  category?: string;
  addresses?: MeteringPointAddress[];
  customerId?: string;
  customerName?: string;
  containedMeteringPoints?: MeteringPoint[];
  disruptionInfos?: DisruptionInfo[];


  hasFunctionControl?: boolean;
  functionControlStatus?: FunctionControlStatus;
  functionControlServiceCode?: string;
  functionControlStartDate?: Date;
  functionControlEndDate?: Date;
  functionControls?: MeteringPointFunctionControl[];
  functionControlsLoaded?: boolean;
  functionControlsLoading?: boolean;

  readings?: MeteringPointReadingPoint[];
  readingsLoaded?: boolean;
  readingsLoading?: boolean;
  
  contractId?: number;
  standardProduct?: string;
  connectedAtDate?: string;
  latestConstructionDate?: string;
  hasIntelligy?: boolean;

  selected?: boolean;
  added?: boolean;
  parentGroups?: { name: string; id: number }[];
  addressLabel?: string;
  intelligyStatus?: MeteringPointIntelligyStatus;

  // External Organisation
  isWhiteLabel?: boolean;
  externalOrganisationId?: number;
  externalOrganisationAlias?: string;

  // Värmefördelning vid brist
  distributionApprovalStatus?: DistributionApprovalStatus;
  distributionFunctionalStatus?: DistributionFunctionalStatus;

  static MockOne(id = 1, name = 'a', customerId = '1') {
    return { id, name, customerId, addresses: [MeteringPointAddress.MockOne(id)] } as MeteringPoint;
  }

  static MockMany() {
    return [MeteringPoint.MockOne(1), MeteringPoint.MockOne(2), MeteringPoint.MockOne(3)];
  }
}

export class MeteringPointAddress {
  type?: string;
  street?: string;
  streetNo?: number;
  zip?: number;
  city?: string;
  littra?: string;
  box?: number;
  coAddress?: string;
  country?: string;

  static MockOne(streetNo = 1, street = 'a') {
    return { streetNo: streetNo, street } as MeteringPointAddress;
  }

  static MockMany() {
    return [MeteringPointAddress.MockOne(1), MeteringPointAddress.MockOne(2)];
  }
}
